(function ($, Cobalt, undefined) {
    Cobalt.Infractions = {
        showAutomaticDescription: function (text) {
            $(".j-automatic-description").text(text);
            if (text == null || text == "") {
                $(".j-automatic-description").hide();
            } else {
                $(".j-automatic-description").fadeIn();
            }
        },
        initialize: function () {
            Cobalt.Infractions.handleBanDefinitionRules();
            
            var validTypesWithRules = [3, 4];
            $(".ban-access-rules").closest(".form-field").hide();
            $("#field-ban-type").change(function () {
                var val = $(this).val();
                if (validTypesWithRules.indexOf(val * 1) != -1) {
                    $(".ban-access-rules").closest(".form-field").show();
                }
                else {
                    $(".ban-access-rules").closest(".form-field").hide();
                }
            });
            $("#field-ban-type").change();

            var infractionActions = $(".infraction-actions");
            if (infractionActions.length > 0) {
                var deleteReason = $(".infraction-action-delete-reason");
                deleteReason.hide();
                infractionActions.find("#field-delete-content").click(function () {
                    var publicWarningText = $(".infraction-warning-text");
                    if ($(this).is(":checked")) {
                        publicWarningText.hide();
                        deleteReason.show();
                    }
                    else {
                        publicWarningText.show();
                        deleteReason.hide();
                    }
                });
            }

            // handle click events for the warning radio buttons
            $("body").on("click", ".j-warning-definition input", function () {
                var $that = $(this);
                var id = $that.data("id")
                // update messages based on selection
                handleWarningMessage(id);

                // disable informal checkboxes
                $(".j-is-slap-on-wrist").prop("disabled", true);

                // enable checkbox that belongs to this warning
                $("#field-warning-" + id).prop("disabled", false);
            });

            // handle the check/uncheck of all the Informal warning check boxes
            $("body").on("change", ".j-is-slap-on-wrist", function (e) {
                e.stopImmediatePropagation();                
                var $that = $(this);
                // update messages based on selection
                handleWarningMessage($that.data("definition-id"));
            });
            
            var handleWarningMessage = function (definitionId) {                
                // find the corresponding option
                var $radio = $(".j-warning-definition input[value='" + definitionId + "']");
                var hasCustomMessage = false;                
                var message = "";
                // if selected
                if ($radio.is(':checked')) {
                    // hide the custom creation div since we are selecting a predefined warning
                    $(".infraction-custom-creation").hide();

                    // check to see if the corresponding informal checkbox is checked
                    var isInformal = $("#field-warning-" + definitionId).prop("checked");
                    if (isInformal) {
                        // update the description to the simple "only informal warning"
                        Cobalt.Infractions.showAutomaticDescription("Only an informal warning.");
                        hasCustomMessage = $radio.data("has-custom-message-inf");
                        message = $radio.data("specific-message-inf");
                        $(".infraction-notification-message-text").html(message);
                    } else {
                        // does the warning have a standard message?
                        // update the description to the description embedded in the option
                        Cobalt.Infractions.showAutomaticDescription($radio.data("description"));
                        hasCustomMessage = $radio.data("has-custom-message");
                        message = $radio.data("specific-message");
                        $(".infraction-notification-message-text").html(message);
                    }

                    // handle custom message notification
                    toggleCustomWarningNotification(hasCustomMessage);                    

                    // toggle the visibility of the custom message editor
                    $(".infraction-notification-custom-message").toggle(hasCustomMessage);
                }

                // hide/show the specific message field depending on if it's displaying anything or not 
                $(".infraction-notification-message").toggle(message ? true : false); // if message is "" or undefined, it will evaluate to falsy
            };

            var warningMessage = false;
            var toggleCustomWarningNotification = function (hasCustomMessage) {
                //adds the warning message that tells users that they can enter a custom warning message
                if (hasCustomMessage && !warningMessage) {
                    $("ul.b-tab-nav").find("[data-tab-id='#notification']").find("span").append('<span id="custom-warning-icon" class="tip" title="This warning allows you to enter a custom message. Use the Notification tab to create one."><i class="u-icon u-icon-warning">!</i></span>');
                    $("div.ui-dialog-footer").prepend('<span id="custom-warning-warning" class="tip" title="This warning allows you to enter a custom message. Use the Notification tab to create one."><i class="u-icon u-icon-warning">!</i></span>');
                    $('.ui-widget .tip').tooltip();
                    warningMessage = true;
                }
                if (!hasCustomMessage) {
                    $("span#custom-warning-icon").remove()
                    $("span#custom-warning-warning").remove();
                    warningMessage = false;
                }
            };

            $(".j-create-custom-warning").on("click", function (e) {
                e.stopImmediatePropagation();
                var isVisible = $(".infraction-custom-creation").toggle().isVisible();
                var $that = $(this);                

                // make sure the custom message notification and editor are displayed
                toggleCustomWarningNotification(true);
                $(".infraction-notification-custom-message").toggle(isVisible);

                // clear the specific warning and hide it
                $(".infraction-notification-message").val("");
                $(".infraction-notification-message").hide();

                $(".j-warning-definition input:checked").prop("checked", false);

                Cobalt.Infractions.showAutomaticDescription(isVisible ? "Custom warning." : "");                
            });
            
            var isPermanentFunc = function () {
                var $that = $("#field-is-permanent-warning");
                if ($that.prop("checked")) {
                    // disable timespan editing
                    $that.parents(".permanent-duration").find(".time-span-container > input,select").prop('disabled', true);
                } else {
                    $that.parents(".permanent-duration").find(".time-span-container > input,select").prop('disabled', false);                 
                }
            };

            $("#field-is-permanent-warning").on("change", isPermanentFunc);
            isPermanentFunc();

            var hellBanTypeValue = 2;
            var onBanChange = function () {
                var $selectedItem = $(this).find("option:selected");
                var $permanentWarning = $("#field-is-permanent-warning");
                var $expireValue = $("#field-expire-value");
                var $expireHiddenValue = $("#field-expire > .hidden-time-span");
                if ($selectedItem.data("ban-type") === hellBanTypeValue) {
                    $expireValue.val(null);
                    $expireHiddenValue.val(null);
                    $expireValue.prop("disabled", true);
                    $permanentWarning.attr("checked", "checked");
                    $permanentWarning.prop("disabled", true);                                        
                } else {
                    $permanentWarning.prop("disabled", false);
                    $expireValue.prop("disabled", false);
                }
            };

            $("#field-ban").on("change", onBanChange);
            onBanChange();

            $("#field-custom-points").on("keyup", function () {
                if ($("#field-custom-warning:checked").length > 0) {
                    Cobalt.Infractions.showAutomaticDescription("Only a an informal warning.");
                }
                else {
                    var userid = $(".j-warning-for").attr("data-userid");
                    var points = $("#field-custom-points").val();
                    var commentid = $(".ajax-warn").data("id");
                    var isComment = $(".ajax-warn").data("is-comment");
                    if (points && points > 0) {
                        if (isComment === "True") {
                            $.get(Cobalt.Routes.Instance.InfractionsGetWarningDefinitionDescriptionByComment(userid, commentid, points), function(data) {
                                if (data) {
                                    if (data.description) {
                                        Cobalt.Infractions.showAutomaticDescription(data.description);
                                    }
                                }
                            });
                        } else {
                            $.get(Cobalt.Routes.Instance.InfractionsGetWarningDefinitionDescription(userid, points), function (data) {
                                if (data) {
                                    if (data.description) {
                                        Cobalt.Infractions.showAutomaticDescription(data.description);
                                    }
                                }
                            });
                        }
                    } else {
                        Cobalt.Infractions.showAutomaticDescription("Points input is required.");
                    }
                }
            });

            $("body").on("click", "a.j-cancel-button", function (e) {
                $(this).parents("div.ui-dialog-content").dialog("close");
            });

        },
        handleBanDefinitionRules: function () {
            if ($(".ban-form-container").length) {
                $("#field-ban-type").on("change", function () {
                    if ($(this).val() === "2") {
                        $(".access-rules-container").hide();
                    } else {
                        $(".access-rules-container").show();
                    }
                });
                $("#field-ban-type").change();

                $("#field-access-rule-type").on("change", function () {
                    var checkedValue = $(this).find("input:checked").val();

                    if (checkedValue === "3") {
                        $(".sectional-rules").show();
                        $(".hidden-rule-field").hide();
                    } else {
                        $(".sectional-rules").hide();
                        $(".hidden-rule-field").show();
                        if (checkedValue === "1") {
                            $(".hidden-rule-field").css("margin-top", "-62px");
                        }
                        if (checkedValue === "2") {
                            $(".hidden-rule-field").css("margin-top", "-40px");
                        }
                    }
                });
                $("#field-access-rule-type").change();

                $(".sectional-rules .section-group input").on("change", function() {
                    if ($(this).is(":checked")) {
                        $(this).parents(".section-group").find("select").show();
                    } else {
                        $(this).parents(".section-group").find("select").hide();
                    }
                });
                $(".sectional-rules .section-group input").change();

                $("#content").css('min-height', '500px');
            }
        },
    };

})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Infractions.js